"use client"

import { useState } from "react"
import { useMediaQuery, Badge } from "@mui/material"
import { ArrowDownLeft, ArrowUpRight, RefreshCw, CreditCard, Bell, Menu, Sparkles, Search } from "lucide-react"
import WrapUpP2p from "../../p2p/layouts/WrapUpP2p"


export default function BalanceOnly({ children }) {
    const [activeTab, setActiveTab] = useState()
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const isMobile = useMediaQuery("(max-width: 768px)")



    return (<WrapUpP2p>

        <h2 className="text-2xl font-bold text-white">My Wallet</h2>
        <div className="rounded-xl bg-gradient-to-r from-purple-900/40 to-blue-900/40 p-6 backdrop-blur-md border border-purple-500/20 shadow-[0_0_15px_rgba(149,76,233,0.25)]">
            <h3 className="text-lg font-medium text-purple-200">Total Balance</h3>
            <p className="mt-2 text-3xl font-bold text-white">$12,456.78</p>
            <div className="mt-4 grid grid-cols-2 gap-4">
                <div className="rounded-lg bg-white/5 p-3">
                    <p className="text-sm text-purple-200">Bitcoin</p>
                    <p className="font-medium text-white">0.128 BTC</p>
                    <p className="text-sm text-cyan-400">$6,245.30</p>
                </div>
                <div className="rounded-lg bg-white/5 p-3">
                    <p className="text-sm text-purple-200">Ethereum</p>
                    <p className="font-medium text-white">3.45 ETH</p>
                    <p className="text-sm text-cyan-400">$6,211.48</p>
                </div>
            </div>
        </div>

    </WrapUpP2p>
    )
}